/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, getter-return */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { attributeBindings, classNames } from '@ember-decorators/component';

@classNames('label')
@attributeBindings('style')
export default class UserBadgeLabel extends Component {
  @computed('count.{isCurrent,daysSinceLatestPost}')
  get style() {
    let days = this.get('count.daysSinceLatestPost');

    if (days >= 480) {
      // Too old to display.
      return htmlSafe('display: none;');
    } else if (days < 80) {
      // New enough that we want full opacity.
      return;
    }

    // Calculate opacity based on how old the latest post is.
    // We want a range of roughly 10-90% opacity, so subtract 40 days first.
    let opacity = Number(1 - (days - 40) / 480).toFixed(2);
    return htmlSafe(`opacity: ${opacity};`);
  }
}
